import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '@kodit/core/services';

//Guard koji sprecava pristup AppLayout-u
@Injectable({
  providedIn: 'root',
})
export class ActiveGuard implements CanActivate {
  constructor(
    private router: Router,
    private jwtHelper: JwtHelperService,
    private auth: AuthService
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this.auth.getToken;

    if (!token) return false;

    const decoded = this.jwtHelper.decodeToken(token);
    const subEnd = decoded?.subscriptionEnd;

    if (!subEnd) return false;

    const expiration = new Date(subEnd);
    const now = new Date();

    const isExpired = expiration < now;

    // Ako je istekla subskripcija ili je tenant inaktivan, ne mozemo pristupiti AppLayout-u
    if (isExpired || !this.auth.getIsTenantActive) {
      this.router.navigate(['/expired']).then();
      return false;
    }

    return true;
  }
}
